import { render, staticRenderFns } from "./DataCell.vue?vue&type=template&id=1884193f"
import script from "./DataCell.vue?vue&type=script&lang=ts"
export * from "./DataCell.vue?vue&type=script&lang=ts"
import style0 from "./DataCell.vue?vue&type=style&index=0&id=1884193f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.12_css-loader@6.11.0_webpack@5.75.0__ejs@3.1.1_86e7ef74e9a65372c82132bf43ab6510/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports